<script>
  import { SendDownloadExcelRequest } from "./APIService";

  let funFairType = 0;
  let limit = 0;

  // values must match the server FunFairType enum
  const funFairTypes = [
    { value: 0, label: "Duck Hunt", name: "UserDuckHunt" },
    { value: 1, label: "Whack A Mole", name: "UserWhackAMole" },
    { value: 2, label: "Jackpot", name: "UserJackpot" },
    { value: 3, label: "Lucky Cards", name: "UserLuckyCards" },
  ];

  function exportFunFairData() {
    const selectedType = funFairTypes.find((t) => t.value === funFairType);
    const rowLimit = Math.max(0, parseInt(limit) || 0);
    const api = `ExportLatestUserFunFairsExcel?funFairType=${funFairType}&limit=${rowLimit}`;

    SendDownloadExcelRequest(api, "GET", `Latest_${selectedType.name}`);
  }
</script>

<div class="card col-md-12">
  <h5 class="card-header"><h3>Export FunFair Data</h3></h5>
  <div class="card-body">
    <p class="text-muted">
      Exports the users data of the latest funfair, sorted by TotalScores.
    </p>

    <div class="mb-3">
      <label class="form-label d-block">FunFair Type:</label>
      {#each funFairTypes as type}
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="funFairTypeOptions"
            id={`radio${type.value}`}
            value={type.value}
            bind:group={funFairType}
          />
          <label class="form-check-label" for={`radio${type.value}`}>
            {type.label}
          </label>
        </div>
      {/each}
    </div>

    <div class="mb-3">
      <label class="form-label" for="funFairLimit">Top users count (0 = all users):</label>
      <input
        class="form-control"
        type="number"
        min="0"
        id="funFairLimit"
        bind:value={limit}
      />
    </div>

    <div class="input-group">
      <button
        class="w-100 btn btn-lg btn-success"
        on:click={exportFunFairData}
      >
        Download Excel File
      </button>
    </div>
  </div>
</div>

<style>
  .card {
    margin: 5px;
  }
</style>
